import * as React from 'react';
import { useAppStore } from '../stores';
import { InputBaseModel } from '../models';

export default <T extends { disabled?: boolean }>(input: InputBaseModel, props: T) => {
    const { controlStateStore } = useAppStore();

    const [disabled, setDisabled] = React.useState<boolean | undefined>();

    React.useEffect(() => {
        if (input.isReadOnly || controlStateStore.inputsDisabled) {
            setDisabled(true);
            return;
        }

        setDisabled(props.disabled);
    }, [controlStateStore.inputsDisabled, props.disabled, input.isReadOnly]);

    return {
        disabled
    };
};
